import { render } from "./RouterLink.vue?vue&type=template&id=38d48ee4&scoped=true"
import script from "./RouterLink.vue?vue&type=script&lang=js"
export * from "./RouterLink.vue?vue&type=script&lang=js"

import "./RouterLink.vue?vue&type=style&index=0&id=38d48ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d48ee4"]])

export default __exports__